/**
 * URLs de la vista recorrido (mapa + ETA) e itinerario.
 * Query principal: `recorrido` (t1a, t2, t5a, …). Sin paradero fijo en URL: la ETA viene del GPS del bus.
 */

/**
 * @param {{ recorridoId?: string | null, paraderoId?: string | null }} p
 * @returns {string} query sin "?"
 */
export function paraderoSearchString({ recorridoId, paraderoId }) {
  const q = new URLSearchParams();
  if (recorridoId) q.set('recorrido', recorridoId);
  if (paraderoId) q.set('paraderoId', paraderoId);
  return q.toString();
}

/**
 * @param {{ recorridoId?: string | null, paraderoId?: string | null }} p
 */
export function paraderoPath({ recorridoId, paraderoId }) {
  const s = paraderoSearchString({ recorridoId, paraderoId });
  return s ? `/paradero?${s}` : '/paradero';
}

/**
 * @param {{ recorridoId?: string | null, sentido?: string | null }} p
 * @returns {string} query sin "?"
 */
export function itinerarioSearchString({ recorridoId, sentido }) {
  const q = new URLSearchParams();
  if (recorridoId) q.set('recorrido', recorridoId);
  if (sentido) q.set('sentido', sentido);
  return q.toString();
}

/**
 * @param {{ recorridoId?: string | null, sentido?: string | null }} p
 */
export function itinerarioPath({ recorridoId, sentido }) {
  const s = itinerarioSearchString({ recorridoId, sentido });
  return s ? `/itinerario?${s}` : '/itinerario';
}

/** Paraderos cerca de la persona (geolocalización o búsqueda por nombre). */
export const CERCA_PATH = '/cerca';

/**
 * Tablero de llegadas de un paradero físico (ids `PF-…`).
 * @param {{ paraderoFisicoId: string }} p
 */
export function llegadasPath({ paraderoFisicoId }) {
  const q = new URLSearchParams({ paradero: paraderoFisicoId });
  return `/llegadas?${q.toString()}`;
}
